import { memo } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemCategory from "../ListItemCategory";
import SidebarRouteItem from "../../SidebarRouteItem";
import type { SidebarRouteGroup } from "components/Sidebar/hooks/useSidebarRouteList/useSidebarRouteList";
import { useTranslation } from "react-i18next";
import ListRouteItem from "./components/ListRouteItem";

interface CategoryItemsProps {
  list: SidebarRouteGroup;
}

function CategoryItems(props: CategoryItemsProps) {
  const { list } = props;

  const { t } = useTranslation();

  return (
    <ListItem disablePadding key={list.title} sx={{ all: "unset", display: "flex", flexDirection: "column" }}>
      <ListItemCategory>{t(list.title)}</ListItemCategory>
      <ListRouteItem>
        {list.items.map((route) => (
          <SidebarRouteItem
            icon={route.icon}
            route={route.route}
            title={route.title}
            locked={route.locked}
            upsell={route.upsell}
            hotspot={route.hotspot}
            key={route.route}
          />
        ))}
      </ListRouteItem>
    </ListItem>
  );
}

export default memo(CategoryItems);
